import { ButtonProps, IconButton } from "@chakra-ui/react";
import IconLog from "assets/icons/icon-log.svg?react";
import { Link, LinkProps } from "react-router-dom";

type IconButtonLogProps = ButtonProps & LinkProps;

export default function IconButtonLog(props: IconButtonLogProps) {
  return (
    <IconButton
      as={Link}
      aria-label="Log"
      size="sm"
      icon={<IconLog />}
      {...props}
    />
  );
}
